import { Suspense, useEffect, useState } from "react";
import type { MantineThemeOverride } from "@mantine/core";
import "./styles/layers.css";
import "@mantine/core/styles.layer.css";
import "@xplatform/design-system/styles.layer.css";
import { LoadingScreen, XPlatformProvider } from "@xplatform/design-system";
import "@src/index.scss";
import { Routes, Route } from "react-router-dom";
import { injectStylesheet } from "@utils/injectStyles";
import { ModuleContextProvider } from "@src/ContextProvider";
import { SearchPage } from "@pages/SearchPage";

const PORTAL_ID = "search-portal-root";

const ModuleApp = () => {
  const [shellOverride, setShellOverride] = useState<
    MantineThemeOverride | undefined
  >(undefined);

  useEffect(() => {
    import("xplatform_shell/theme")
      .then((mod) => {
        if (mod.theme) setShellOverride(mod.theme);
      })
      .catch(() => {});
    const base = import.meta.env.BASE_URL || "/";
    injectStylesheet(`${base}assets/style.css`);
  }, []);

  return (
    <XPlatformProvider theme={shellOverride}>
      <ModuleContextProvider>
        <Suspense fallback={<LoadingScreen message="Loading..." />}>
          <Routes>
            <Route index element={<SearchPage />} />
          </Routes>
        </Suspense>
      </ModuleContextProvider>
      <div
        id={PORTAL_ID}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          pointerEvents: "none",
          zIndex: 9999,
        }}
      />
    </XPlatformProvider>
  );
};

export default ModuleApp;
